import { __assign, __extends, __spreadArrays } from "tslib";
import classnames from 'classnames';
import union from 'lodash/union';
import React from 'react';
import Select from 'react-select';
import { isNode } from "../../models/node";
import "../../../style/components/dropDownListWithSearch.scss";
var DropDownListWithSearch = (function (_super) {
    __extends(DropDownListWithSearch, _super);
    function DropDownListWithSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (selectedOption) {
            var optionSelectedCallback = _this.props.optionSelectedCallback;
            if (optionSelectedCallback && selectedOption) {
                if (typeof selectedOption === 'object' && selectedOption.value) {
                    optionSelectedCallback(selectedOption.value);
                }
                else {
                    var values = selectedOption.map(function (option) { return option.value; });
                    optionSelectedCallback(values);
                }
            }
        };
        _this.onInputChange = function (value, groups) {
            var hideOptions = _this.props.hideOptions;
            if (hideOptions) {
                if (value.length === 0) {
                    _this.setState({
                        expandedGroups: [],
                        showOptions: false,
                    });
                }
                if (value.length >= 1) {
                    _this.setState({
                        expandedGroups: groups,
                        showOptions: true,
                    });
                }
            }
        };
        _this.onMenuClose = function () {
            _this.selectRef.blur();
        };
        _this.formatGroupLabel = function (option) {
            var _a = _this.state, expandedGroups = _a.expandedGroups, showOptions = _a.showOptions;
            var label = option.label;
            var isExpanded = false;
            if (expandedGroups.indexOf(label) !== -1 || showOptions) {
                isExpanded = true;
            }
            return (React.createElement("div", { style: { borderBottom: isExpanded ? 'none' : null }, className: 'rb-dropdown-with-search-group-heading', onClick: function () { return _this.toggleOptions(label); } },
                React.createElement("div", { className: 'rb-group-heading-label' }, label),
                React.createElement("div", { className: classnames({
                        'rb-group-heading-indicator': true,
                        'is-expanded': isExpanded,
                    }) },
                    React.createElement("div", null))));
        };
        _this.formatOptionLabel = function (option, labelMeta) {
            var _a = _this.state, expandedGroups = _a.expandedGroups, showOptions = _a.showOptions;
            if (labelMeta.context === 'value') {
                return (React.createElement("div", { className: 'rb-dropdown-with-search-label' },
                    React.createElement("div", { className: 'rb-option-label' }, option.label)));
            }
            if (expandedGroups.indexOf(option.group) === -1 && !showOptions) {
                return null;
            }
            return (React.createElement("div", { className: 'rb-dropdown-with-search-label' },
                React.createElement("div", { className: 'rb-option-label' }, option.label),
                option.description &&
                    React.createElement("div", { className: 'rb-tooltip' },
                        React.createElement("div", null, option.description))));
        };
        _this.toggleOptions = function (label) {
            var expandedGroups = _this.state.expandedGroups;
            var index = expandedGroups.indexOf(label);
            if (index === -1) {
                _this.setState({
                    expandedGroups: __spreadArrays(expandedGroups, [label]),
                    showOptions: false,
                });
            }
            else {
                var updatedExpandedGroups = __spreadArrays(expandedGroups);
                updatedExpandedGroups.splice(index, 1);
                _this.setState({
                    expandedGroups: updatedExpandedGroups,
                    showOptions: false,
                });
            }
        };
        _this.state = {
            expandedGroups: [],
            showOptions: !props.hideOptions,
        };
        return _this;
    }
    DropDownListWithSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, list = _a.list, placeholder = _a.placeholder, selected = _a.selected, disabled = _a.disabled, noResultsText = _a.noResultsText, isClearable = _a.isClearable, isMulti = _a.isMulti;
        var groups = null;
        var options = [];
        if (list && list.length > 0) {
            options = list.map(function (listItem) {
                if (isNode(listItem)) {
                    if (!groups) {
                        groups = _this.getGroups(listItem.groups);
                    }
                    else {
                        groups = union(groups, _this.getGroups(listItem.groups));
                    }
                    return {
                        value: listItem.name,
                        label: listItem.title,
                        description: listItem.description,
                        groups: listItem.groups,
                    };
                }
                return {
                    value: listItem,
                    label: listItem,
                };
            });
        }
        var value = null;
        if (selected) {
            if (typeof selected === 'string') {
                for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                    var option = options_1[_i];
                    if (option.value === selected) {
                        value = option;
                        break;
                    }
                }
            }
            else {
                value = [];
                for (var _b = 0, selected_1 = selected; _b < selected_1.length; _b++) {
                    var selectedValue = selected_1[_b];
                    for (var _c = 0, options_2 = options; _c < options_2.length; _c++) {
                        var option = options_2[_c];
                        if (option.value === selectedValue) {
                            value.push(option);
                            break;
                        }
                    }
                }
            }
        }
        var groupedOptions = [];
        if (groups && groups.length > 0) {
            groups.sort();
            for (var _d = 0, groups_1 = groups; _d < groups_1.length; _d++) {
                var group = groups_1[_d];
                groupedOptions.push({
                    label: group,
                    options: this.getGroupOptions(options, group),
                });
            }
        }
        else {
            groupedOptions = options;
        }
        var isDisabled = options.length === 0 || disabled;
        return (React.createElement(Select, { className: 'rb-dropdown-with-search-container', classNamePrefix: 'rb-dropdown-with-search', ref: function (ref) { return _this.selectRef = ref; }, options: groupedOptions, value: value, placeholder: placeholder, onChange: this.onChange, onInputChange: function (inputValue) { return _this.onInputChange(inputValue, groups); }, onMenuClose: this.onMenuClose, noOptionsMessage: function () { return (noResultsText); }, isDisabled: isDisabled, isClearable: isClearable, formatGroupLabel: this.formatGroupLabel, formatOptionLabel: this.formatOptionLabel, menuShouldScrollIntoView: false, openMenuOnFocus: true, isMulti: isMulti }));
    };
    DropDownListWithSearch.prototype.getGroups = function (optionGroups) {
        var groups = [];
        if (optionGroups && optionGroups.length > 0) {
            for (var _i = 0, optionGroups_1 = optionGroups; _i < optionGroups_1.length; _i++) {
                var optionGroup = optionGroups_1[_i];
                if (groups.indexOf(optionGroup) === -1) {
                    groups.push(optionGroup);
                }
            }
        }
        return groups;
    };
    DropDownListWithSearch.prototype.getGroupOptions = function (options, group) {
        var groupOptions = [];
        for (var _i = 0, options_3 = options; _i < options_3.length; _i++) {
            var option = options_3[_i];
            var newOption = __assign({}, option);
            if (newOption.groups) {
                for (var _a = 0, _b = newOption.groups; _a < _b.length; _a++) {
                    var newOptionGroup = _b[_a];
                    if (newOptionGroup === group) {
                        newOption.group = group;
                        groupOptions.push(newOption);
                    }
                }
            }
        }
        return groupOptions;
    };
    return DropDownListWithSearch;
}(React.PureComponent));
export { DropDownListWithSearch };
